// extracted by css-extract-rspack-plugin
export default {"colorSquare":"_1Wt57tgowzOuZkzu1-d8H6"};